module.exports = __webpack_public_path__ + "static/img/anxun13.d28c0f61.png";